// ForgotPassword.jsx
import React, { useState } from "react";
import axios from "../axios/axios";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/auth/forgot-password", { email });
      setMessage("Reset token sent via Email.");
      navigate("/verify-otp", { state: { email } });
    } catch (error) {
      setMessage(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div
      className=" d-flex flex-column justify-content-center"
      style={{ height: "100vh" }}
    >
      <div className="">
        <h2 className="text-center mb-5 fw-bold">Forgot Password</h2>
        <form onSubmit={handleForgotPassword} className="container w-50">
          <input
            className="form-control shadow-none "
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="btn bg_maincolor text-white mt-4">
            Send OTP
          </button>
        </form>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ForgotPassword;
